module.exports = __webpack_public_path__ + "img/selected_sensor_ok.d029fbb6.svg";